export default "__VITE_PUBLIC_ASSET__21955167__"